import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './Navbar';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import Restaurants from './pages/Restaurants';
import RestaurantDetails from './pages/RestaurantDetails';
import Drivers from './pages/Drivers';
import DriverDetails from './pages/DriverDetails';
import DriverGroups from './pages/DriverGroups';
import Slots from './pages/Slots';
import DriverGroupVisibility from './pages/DriverGroupVisibility';
import Clients from './pages/Clients';
import ClientDetails from './pages/ClientDetails';
import TelegramBotChats from './pages/TelegramBotChats';
import Reviews from './pages/Reviews';
import SearchDrivers from './pages/SearchDrivers';
import Settings from './pages/Settings';
import Admins from './pages/Admins';
import Statistics from './pages/Statistics';
import DeliveryPolygons from './pages/DeliveryPolygons';
import AutoAcceptRules from './pages/AutoAcceptRules';
import Banners from './pages/Banners';
import RestaurantCategories from './pages/RestaurantCategories';
import Notifications from './pages/Notifications';
import { AdminResponse, AdminType } from '../types/auth';
import { AuthProvider } from '../contexts/AuthContext';
import './MainLayout.css';

interface MainLayoutProps {
  onLogout: () => void;
  currentAdmin: AdminResponse | null;
}

const MainLayout: React.FC<MainLayoutProps> = ({ onLogout, currentAdmin }) => {
  const isSuperAdmin = currentAdmin?.adminType === AdminType.SUPER_ADMIN;

  return (
    <AuthProvider currentAdmin={currentAdmin}>
      <div className="main-layout">
        <Navbar onLogout={onLogout} currentAdmin={currentAdmin} />
        <div className="content">
          <Routes>
            <Route path="/" element={<Navigate to="/orders" replace />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/order-details/:orderId" element={<OrderDetails />} />
            <Route path="/restaurants" element={<Restaurants />} />
            <Route path="/restaurants/:restaurantId" element={<RestaurantDetails />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/drivers/:driverId" element={<DriverDetails />} />
            <Route path="/driver-groups" element={<DriverGroups />} />
            <Route path="/slots" element={<Slots />} />
            <Route path="/driver-group-visibility" element={<DriverGroupVisibility />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/telegram-bot-chats" element={<TelegramBotChats />} />
            <Route path="/clients/:clientId" element={<ClientDetails />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/search-drivers" element={<SearchDrivers />} />
            {isSuperAdmin && <Route path="/settings" element={<Settings />} />}
            {isSuperAdmin && <Route path="/delivery-polygons" element={<DeliveryPolygons />} />}
            {isSuperAdmin && <Route path="/auto-accept-rules" element={<AutoAcceptRules />} />}
            {isSuperAdmin && <Route path="/banners" element={<Banners />} />}
            {isSuperAdmin && <Route path="/restaurant-categories" element={<RestaurantCategories />} />}
            {isSuperAdmin && <Route path="/admins" element={<Admins />} />}
            {isSuperAdmin && <Route path="/statistics" element={<Statistics />} />}
          </Routes>
        </div>
      </div>
    </AuthProvider>
  );
};

export default MainLayout;
